<script setup lang="ts">
	import { gsap } from "gsap"
	import { onClickOutside } from '@vueuse/core'

	const isOpen = ref(0)
	const toggle = ref(null)
	const content = ref(null)
	const wrapper = ref(null)

	const init = ( () => {
		gsap.set(content.value, { width: 0, opacity:0 })
		gsap.set(toggle.value, { width: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, height: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, y: 0 })
	})

	onMounted(() => {
		init()
		useEventListener(window, 'resize', function(){
			init()
		})
	})

	const toggleBtn = (event:any) => {
		if(isOpen.value === 0 ) {
			gsap.to(toggle.value, { width: () => { return screen.width >= 1180 ? 50 : screen.width >= 768 ? 42 : 38 }, height: () => { return screen.width >= 1180 ? 50 : screen.width >= 768 ? 42 : 38 }, x: -5, y: 5, duration: 0.35, ease: "power4.inOut" })
			gsap.to(content.value, { width: () => { return screen.width >= 1180 ? 250 : screen.width >= 991 ? 220 : screen.width >= 575 ? 210 : 190 }, opacity: 1, duration: 0.5, ease: "back.inOut" })
		} else {
			closeArea()
		}
		isOpen.value = (isOpen.value - 1) * -1
	}

	const closeArea = () => {
		gsap.to(toggle.value, { width: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, height: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, x: 0, y: 0, duration: 0.35, ease: "power4.inOut" })
		gsap.to(content.value, { width: 0, opacity:0, duration: 0.5, ease: "power4.in" })
	}

	onClickOutside(wrapper, event => {
		if(isOpen.value) {
			closeArea()
			isOpen.value = 0
		}
	})
</script>

<template>
	<div ref="wrapper" class="relative group" aria-label="Kontaktdaten anzeigen" title="Kontaktdaten anzeigen">
		<div ref="content" class="flex justify-center h-[48px] md:h-[52px] lg:h-[60px] bg-blue group-hover:bg-green rounded-full pr-[48px] md:pr-[52px] lg:pr-[60px] shadow-lg overflow-hidden">
			<div class="flex space-x-2 my-auto pt-1 ps-5">
				<router-link to="/kontakt" class="my-auto text-white text-[14px] md:text-[16px] lg:text-[20px] whitespace-nowrap underline-offset-4">Kontakt</router-link>
				<span class="my-auto text-white text-[14px] md:text-[16px] lg:text-[20px]"> | </span>
				<router-link to="/feedback" class="my-auto text-white text-[14px] md:text-[16px] lg:text-[20px] whitespace-nowrap underline-offset-4">Feedback</router-link>
			</div>
		</div>
		<button ref="toggle" aria-label="Kontakte anzeigen" @click="toggleBtn($event)" class="absolute right-0 top-0 w-[48px] h-[48px] md:w-[52px] md:h-[52px] lg:w-[60px] lg:h-[60px] rounded-full bg-blue group-hover:bg-green border-blue p-0 cursor-pointer">
			<span class="m-auto">
				<svg xmlns="http://www.w3.org/2000/svg" width="38.962" height="33.616" viewBox="0 0 38.962 33.616" class="w-[28px] lg:w-[32px] m-auto">
					<g id="Layer_2" data-name="Layer 2" transform="translate(-1.25 -3.25)">
						<path id="Pfad_6916" data-name="Pfad 6916" d="M13.855,36.866a3.625,3.625,0,0,1-.87-.127,3.153,3.153,0,0,1-2.229-2.283l-.689-2.773a.471.471,0,0,0-.435-.344H4.421A3.189,3.189,0,0,1,1.25,28.167V6.421A3.171,3.171,0,0,1,4.421,3.25H37.041a3.171,3.171,0,0,1,3.171,3.171V28.167a3.189,3.189,0,0,1-3.171,3.171H20.85a.471.471,0,0,0-.308.127l-4.458,4.458a3.117,3.117,0,0,1-2.229.942ZM4.421,5.968a.453.453,0,0,0-.453.453V28.168a.453.453,0,0,0,.453.453H9.632a3.171,3.171,0,0,1,3.081,2.41l.689,2.755a.4.4,0,0,0,.308.326A.417.417,0,0,0,14.163,34l4.458-4.458a3.189,3.189,0,0,1,2.229-.924H37.041a.453.453,0,0,0,.453-.453V6.421a.453.453,0,0,0-.453-.453Z" transform="translate(0 0)" fill="#fff"/>
						<circle id="Ellipse_11" data-name="Ellipse 11" cx="2.265" cy="2.265" r="2.265" transform="translate(10.311 15.029)" fill="#fff"/>
						<circle id="Ellipse_12" data-name="Ellipse 12" cx="2.265" cy="2.265" r="2.265" transform="translate(18.466 15.029)" fill="#fff"/>
						<circle id="Ellipse_13" data-name="Ellipse 13" cx="2.265" cy="2.265" r="2.265" transform="translate(26.621 15.029)" fill="#fff"/>
					</g>
				</svg>
			</span>
		</button>
	</div>
</template>
